import React from "react";
import { useTranslation } from "react-i18next";
import "./Cards.css";
import CardItem from "../CardItem/CardItem";

function Cards() {
  const { t } = useTranslation();

  return (
    <div className="cards">
      <div className="cards-header">
        <h1>{t("cards.header.title")}</h1>
      </div>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="/images/main/task_lists.png"
              label={t("cards.todo.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/share_notes.png"
              label={t("cards.note.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/shopping_lists.png"
              label={t("cards.shopping.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/plan_events.png"
              label={t("cards.calendar.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/add_schedules.png"
              label={t("cards.schedule.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/polls_decisions.png"
              label={t("cards.voting.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/expenses.png"
              label={t("cards.budget.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/reports_overview.png"
              label={t("cards.finance.title")}
              path="/app"
            />
          </ul>

          <div className="cards-header">
            <h1>{t("cards.premium.title")}</h1>
          </div>

          <ul className="cards__items">
            <CardItem
              src="/images/main/tracking.png"
              label={t("cards.tracking.title")}
              path="/app"
            />
            <CardItem
              src="/images/main/chat.png"
              label={t("cards.chat.title")}
              path="/app"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
